<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

    export default {
        name: 'App',
    }
</script>

<style>
  @import "../node_modules/material-design-iconic-font/dist/css/material-design-iconic-font.min.css";
  @import "../node_modules/animate.css/animate.min.css";
  @import "../node_modules/select2/dist/css/select2.min.css";
  @import "../node_modules/sweetalert2/dist/sweetalert2.min.css";
  @import "../node_modules/jquery.scrollbar/jquery.scrollbar.css";
  @import "~vue2-dropzone/dist/vue2Dropzone.min.css";
</style>
<style lang="scss">
  @import "./assets/scss/main.scss";
</style>
<style lang="scss">@import "@/assets/scss/_app.scss";</style>